// extracted by mini-css-extract-plugin
export default {"closeBtn":"ClosePageOverPictureButtonwithModal_closeBtn__sdE0x","iconX":"ClosePageOverPictureButtonwithModal_iconX__ik8se"};